module.exports = __webpack_public_path__ + "media/images/pages/fcr-flow/step-11-1fe0643cb0ba52356d0dd2741aaec420.png";